import Phaser from "phaser";
export const EightDirections = ["n", "ne", "e", "se", "s", "sw", "w", "nw"] as const;
export const FourDirections = ["n", "e", "s", "w"] as const;

export type EightDirection = typeof EightDirections[number];
export type FourDirection = typeof FourDirections[number];

export function direction8FromVector(x: number, y: number, fallback: EightDirection = "s"): EightDirection {
  if (Math.abs(x) < 0.001 && Math.abs(y) < 0.001) return fallback;
  const degrees = Phaser.Math.RadToDeg(Math.atan2(y, x));
  if (degrees >= -22.5 && degrees < 22.5) return "e";
  if (degrees >= 22.5 && degrees < 67.5) return "se";
  if (degrees >= 67.5 && degrees < 112.5) return "s";
  if (degrees >= 112.5 && degrees < 157.5) return "sw";
  if (degrees >= 157.5 || degrees < -157.5) return "w";
  if (degrees >= -157.5 && degrees < -112.5) return "nw";
  if (degrees >= -112.5 && degrees < -67.5) return "n";
  return "ne";
}

export function direction4FromAngle(angle: number): FourDirection {
  const degrees = Phaser.Math.RadToDeg(angle);
  if (degrees >= -45 && degrees < 45) return "e";
  if (degrees >= 45 && degrees < 135) return "s";
  if (degrees >= 135 || degrees < -135) return "w";
  return "n";
}
